// @flow
export const containsEmptySpaces = (value: string): boolean => /\s/.test(value);

export const isStringValue = (value: any): boolean => typeof value === 'string' || value instanceof String;
